<template>
  <div>
    <menubar :permission="permission" />
    <div id="app" class="container">
      <div class="title-btn d-flex justify-content-between align-items-center">
        <div id="title" class="d-flex justify-content-start">
          <img src="/img/05_slash.svg" />
          <p class="h1">ユーザー管理</p>
        </div>
        <modal>
          <template v-slot:activator="{ openModal }">
            <button
              class="btn btn-purple show-modal"
              @click="
                openModal();
                setModalContent();
              "
            >
              ユーザー登録
            </button>
          </template>

          <template v-slot:modalTitle>
            <div v-if="showEntryModal">ユーザー登録</div>
          </template>
          <template v-slot:modal-content="{ closeModal }">
            <div v-if="showEntryModal">
              <div class="mb-4">
                <label class="form-label">ユーザー名<span class="mx-2 badge rounded-pill bg-danger">必須</span></label>
                <input type="text" class="form-control" v-model="entryName" />
              </div>

              <div class="mb-4">
                <label for="exampleInputEmail1" class="form-label">メールアドレス<span class="mx-2 badge rounded-pill bg-danger">必須</span></label>
                <input type="email" class="form-control" id="exampleInputEmail1" v-model="entryEmail" />
              </div>

              <div class="mb-4">
                <label class="form-label"
                  >所属チーム<span class="mx-2 badge rounded-pill bg-danger"
                    >必須</span
                  ></label
                >
                <select class="form-select " v-model="entryTeamId">
                  <option
                    v-for="team in teams"
                    :key="team"
                    v-bind:value="team.id"
                  >
                    {{ team.name }}
                  </option>
                </select>
              </div>



              <div class="mb-4">
                <label class="form-label">権限<span class="mx-2 badge rounded-pill bg-danger">必須</span></label>
                <select class="form-select" v-model="entryAuthority">
                  <option selected disabled value="">選択してください</option>
                  <option>オーナー</option>
                  <option>マネージャー</option>
                  <option>メンバー</option>
                  <option>ゲスト</option>
                </select>
              </div>

              <div class="mb-4">
                <label for="entryComment" class="form-label">備考</label>
                <input type="text" class="form-control" id="entryComment" v-model="entryComment" />
              </div>
            </div>

            <div v-if="showAlertModal">
              <p>ユーザー登録数が契約プランの上限を超えます。ユーザーを削除するか、契約プランの変更お手続きをお願いします。</p>
            </div>

            <div class="modal-btn d-flex justify-content-evenly" v-if="showEntryModal">
              <button class="btn btn-red" @click="closeModal()">キャンセル</button>
              <button
                class="btn btn-purple"
                @click="
                  closeModal();
                  submitNewUser();
                "
              >
                登録
              </button>
            </div>
          </template>
        </modal>
      </div>
      <div id="user-table-head">
        <div class="user-count" style="padding-right: 50px">
          ユーザー数
          <span class="badge display-user mx-1" style="background: #a07abe">{{ countUser }}</span>
        </div>
        <div class="user-count text-gray">
          オーナー
          <span class="badge display-user mx-1 me-4">{{ countAdministrator }}</span>
        </div>
        <div class="user-count text-gray">
          マネージャー
          <span class="badge display-user mx-1 me-4">{{ countManager }}</span>
        </div>
        <div class="user-count text-gray">
          メンバー
          <span class="badge display-user mx-1 me-4">{{ countMember }}</span>
        </div>
        <div class="user-count text-gray">
          ゲスト
          <span class="badge display-user mx-1 me-4">{{ countGuest }}</span>
        </div>
      </div>

      <table class="table component_table">
        <thead>
          <tr style="text-align: center">
            <th class="row-small">No.</th>
            <th class="cell-wide">ユーザー名</th>
            <th class="cell-wide">メールアドレス</th>
            <th class="cell-wide">権限</th>
            <th style="width: 30%">備考</th>
            <th class="row-small">編集</th>
            <th class="row-small">削除</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in users" :key="index">
            <td class="row-small" style="text-align: center">
              {{ index + 1 }}
            </td>
            <td class="cell-wide">
              <span class="badge invited-user" v-show="showUserInvited(user.status)">{{ user.status }}</span>
              {{ user.name }}
            </td>
            <td class="cell-wide" style="overflow-wrap: break-word">
              {{ user.email }}
            </td>
            <td class="cell-wide">{{ user.authority }}</td>
            <td class="cell-wide" style="overflow-wrap: break-word">{{ user.comment }}</td>
            <td class="row-small">
              <modal>
                <template v-slot:activator="{ openModal }">
                  <div style="text-align: center">
                    <img
                      src="/img/17_edit.svg"
                      alt="編集画面へ"
                      width="20"
                      @click="
                        openModal();
                        setEditFormDefault(user, index);
                      "
                    />
                  </div>
                </template>

                <template v-slot:modalTitle> ユーザー編集 </template>
                <template v-slot:modal-content="{ closeModal }">
                  <div>
                    <div class="mb-4">
                      <label class="form-label">ユーザー名<span class="mx-2 badge rounded-pill bg-danger">必須</span></label>
                      <input type="text" class="form-control" v-model="entryName" />
                    </div>

                    <div class="mb-4">
                      <label for="exampleInputEmail1" class="form-label">メールアドレス<span class="mx-2 badge rounded-pill bg-danger">必須</span></label>
                      <input type="email" class="form-control" id="exampleInputEmail1" v-model="entryEmail" />
                    </div>

                    <div class="mb-4">
                      <label class="form-label">権限<span class="mx-2 badge rounded-pill bg-danger">必須</span></label>
                      <select class="form-select" v-model="entryAuthority">
                        <option>オーナー</option>
                        <option>マネージャー</option>
                        <option>メンバー</option>
                        <option>ゲスト</option>
                      </select>
                    </div>

                    <div class="mb-4">
                      <label for="entryComment" class="form-label">備考</label>
                      <input type="text" class="form-control" id="entryComment" v-model="entryComment" />
                    </div>
                  </div>

                  <div class="modal-btn d-flex justify-content-evenly">
                    <button class="btn btn-red" @click="closeModal()">キャンセル</button>
                    <button
                      class="btn btn-purple"
                      @click="
                        closeModal();
                        submitUserEdit(index);
                      "
                    >
                      登録
                    </button>
                  </div>
                </template>
              </modal>
            </td>
            <td class="row-small" style="text-align: center">
              <input :id="index" type="checkbox" :value="index" v-model="selectedUsers" />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="delete-row text-end">
        <button class="btn btn-red" @click="deleteUsers">削除</button>
      </div>
    </div>
    <footerComponent />
  </div>
</template>
<script>
import modal from "@/Pages/Components/modal.vue";
import menubar from "@/Pages/Common/menu.vue";
import footerComponent from "@/Pages/Components/footer.vue";

export default {
  components: { menubar, modal, footerComponent },
  data() {
    return {
      showEntryModal: false,
      showAlertModal: false,
      entryId: 0,
      entryName: "",
      entryTeamId: "",
      entryEmail: "",
      entryAuthority: "",
      entryComment: "",
      errors: [],
      selectedUsers: [],
    };
  },
  props: {
    users: Array,
    teams: Array,
    userlimit: Number,
    csrf_token: String,
    permission: String,
  },
  computed: {
    countUser() {
      return this.users.length;
    },
    countAdministrator() {
      const result = this.users.filter((x) => x.authority === "オーナー");
      return result.length;
    },
    countManager() {
      const result = this.users.filter((x) => x.authority === "マネージャー");
      return result.length;
    },
    countMember() {
      const result = this.users.filter((x) => x.authority === "メンバー");
      return result.length;
    },
    countGuest() {
      const result = this.users.filter((x) => x.authority === "ゲスト");
      return result.length;
    },
  },
  methods: {
    showUserInvited(status) {
      if (status == "招待中") {
        return true;
      } else {
        return false;
      }
    },
    setModalContent() {
      if (this.countUser >= this.userlimit) {
        this.showAlertModal = true;
        this.showEntryModal = false;
      } else {
        this.showAlertModal = false;
        this.showEntryModal = true;

        // inputの初期化
        this.entryName = "";
        this.entryTeamId = 0;
        this.entryEmail = "";
        this.entryAuthority ="";
        this.entryComment ="";  
      }
    },
    setEditFormDefault(user, index) {
      this.entryId = user.id;
      this.entryName = user.name;
      this.entryTeamId = user.teamId;
      this.entryEmail = user.email;
      this.entryAuthority = user.authority;
      this.entryComment = user.comment;
    },
    checkForm(checkTeamId) {
      this.errors = [];
      if (this.entryName && (this.entryTeamId || ! checkTeamId) && this.entryEmail && this.entryAuthority) {
        return true;
      }
      if (!this.entryName) {
        this.errors.push("氏名");
      }
      if (!this.entryTeamId && checkTeamId) {
        this.errors.push("所属チーム");
      }
      if (!this.entryEmail) {
        // TODO メールアドレスの書式をチェック, 登録済みメールアドレスを弾くとか？
        this.errors.push("メールアドレス");
      }
      if (!this.entryAuthority) {
        this.errors.push("権限");
      }
      return false;
    },
    submitNewUser() {
      if (this.checkForm(true)) {
        // TODO console.logに登録済みを出す

        const user = {
          name: this.entryName,
          team_id: this.entryTeamId,
          email: this.entryEmail,
          authority: this.entryAuthority,
          comment: this.entryComment,
        };

        axios
          .post("/users", user, {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "X-CSRF-TOKEN": this.csrf_token,
            },
          })
          .then((response) => {
            if (response.status === 204) {
              location.reload();
            }
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      } else {
        alert(this.errors + "を入力してください。");
      }
    },
    submitUserEdit(index) {
      if (this.checkForm(false)) {
        const id = this.users[index].id;
        console.log(this.users);

        const user = {
          name: this.entryName,
          email: this.entryEmail,
          authority: this.entryAuthority,
          comment: this.entryComment,
        };

        axios
          .put("/users/" + id, user, {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "X-CSRF-TOKEN": this.csrf_token,
            },
          })
          .then((response) => {
            if (response.status === 204) {
              location.reload();
            }
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      } else {
        alert(this.errors + "を入力してください。");
      }
    },
    deleteUsers() {
      if (this.selectedUsers.length == 0){
        alert("削除するユーザを選択してください。");
        return;
      }
      if (confirm("ユーザーを削除してもよろしいですか？")) {
        this.selectedUsers = this.selectedUsers.filter((index)=> this.users[index]!= undefined);
        const ids = this.selectedUsers.map((a)=>this.users[a].id);
          this.$inertia.delete("/users/" + ids.join(','), {
          onSuccess:() =>{ 
            this.selectedUsers = [];
            alert('ユーザーを削除しました。'); 
          },
          onError:(error)=>{
            alert(error.message);
          }
        });
  };}
}
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 80vh; //footer用定義

  #title {
    margin: 3rem 0;
    img {
      width: 3rem;
      height: 3rem;
    }
    p {
      color: #333333;
    }
  }
  #user-table-head {
    display: flex;
    margin: 1rem 0;
  }
  .user-count {
    display: inline;
    width: fit-content;
    padding: 0 20px 0 0;
  }
  .text-gray {
    color: #666666;
  }

  th,
  td {
    padding: 10px;
  }
  .row-small {
    width: 4rem;
  }
  tbody {
    border-top: 0; // bootstrapの線を打ち消し
  }
  .cell-wide {
    max-width: 12rem;
    min-width: fit-content;
    padding: 10px 10px 10px 15px;
  }
  .delete-row {
    margin: 1rem 0;
  }
}

.form-label {
  font-size: 1.1rem;
  color: #333333;
}
</style>
